/* import __COLOCATED_TEMPLATE__ from './recent-searches.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import storage from 'embercom/vendor/intercom/storage';
import { tracked } from '@glimmer/tracking';
import type Session from 'embercom/services/session';

interface Args {
  isQaMode?: boolean;
}

interface Signature {
  Args: Args;
}

export const LOCALSTORAGE_RECENT_SEARCHES_KEY = 'search-v2-recent-searches';
export default class SearchV2RecentSearches extends Component<Signature> {
  @service declare router: RouterService;
  @tracked recentSearches: string[] = storage.get(LOCALSTORAGE_RECENT_SEARCHES_KEY);
  @service declare session: Session;

  get hasRecentSearches() {
    return this.recentSearches && this.recentSearches.length > 0;
  }

  get isStandalone() {
    return this.session.workspace.hasLightStandaloneInbox;
  }

  @action onSelect(query: string) {
    this.router.transitionTo('inbox.workspace.inbox.search', {
      queryParams: { query },
    });
  }

  @action onClose(index: number) {
    let filteredSearches = this.recentSearches.filter(
      (_: string, searchIndex: number) => index !== searchIndex,
    );
    storage.set(LOCALSTORAGE_RECENT_SEARCHES_KEY, filteredSearches);
    this.recentSearches = filteredSearches;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::RecentSearches': typeof SearchV2RecentSearches;
    'inbox2/search/recent-searches': typeof SearchV2RecentSearches;
  }
}
